module.exports = __webpack_public_path__ + "static/media/event1.f1e0bd12.jpg";